export const
    TYPE_RESET = 'type_reset',
    TYPES_RESET = 'types_reset',
    TYPES_PENDING = 'types_pending',
    TYPE_FOCUS = 'type_focus',
    TYPE_DELETED = 'type_deleted',
    TYPE_POSTING = 'type_posting',
    TYPE_EDITING = 'type_editing',
    TYPE_DELETING = 'type_deleting',
    TYPE_FAILED = 'type_failed',
    TYPES_FAILED = 'types_failed',
    TYPE_DOWNLOADED = 'type_downloaded',
    TYPES_DOWNLOADED = 'types_downloaded',
    TYPE_PICTURE_UPLOADING = 'type_picture_uploading',
    TYPE_PICTURE_FAILED = 'type_picture_failed',
    TYPE_PICTURE_UPLOADED = 'type_picture_uploaded',
    TYPE_PICTURE_DELETING = 'type_picture_deleting';



// WEBPACK FOOTER //
// src/store/types/types.js